import React from 'react';
import CustomButton from '../../../../features/customButton/ui/main/CustomButton';
import { safeHTML } from '../../../../../utils/safeHTML';
import classNames from 'classnames';
import { splitTextFromSecretSymbol } from '../../../../../utils/splitTextFromSecretSymbol';
import { useTranslation } from '../../../../../translations';
import { useWishes } from '../../../../../redux/reducer/content';
import useDebounce from '../../../../../hooks/shared/optimization/useDebounce';

export default function Info({ isHiddenWishCard, chooseElf }) {
  const { data, step } = useWishes();
  const { t } = useTranslation();

  const wishData = useDebounce(data, 500);

  const title = isHiddenWishCard
    ? step === 1
      ? t('friends.postcard.chooseElfPose')
      : t('friends.postcard.chooseBackground')
    : t('8march.congratulate8march', { name: wishData?.name, space: ' ' });

  return (
    <div className={classNames(`wish__content-info`, { 'wish__content-info_share': !isHiddenWishCard })}>
      <h2
        className={classNames('wish__content-title', {
          'wish__content-title_share': !isHiddenWishCard,
          'wish__content-title_black': wishData?.image?.is_black_text,
          'wish__content-title_min': title.length > 26,
        })}
      >
        {safeHTML(title)}
      </h2>
      {isHiddenWishCard ? (
        <CustomButton text={'friends.postcard.chooseButton'} onClick={() => chooseElf()} />
      ) : (
        <p
          className={classNames('wish__content-text', 'wish__content-text_share', {
            'wish__content-text_black': wishData?.image?.is_black_text,
          })}
        >
          {safeHTML(splitTextFromSecretSymbol(wishData?.text?.value))}
        </p>
      )}
    </div>
  );
}
